module.exports = "/images/logo-green-white-beta.svg?828947f44fe4eba10f62e881e57e184a";